"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _index = _interopRequireDefault(require("keycode/index"));
var _Input = _interopRequireDefault(require("@mui/material/Input"));
var _HiIcon = _interopRequireDefault(require("../HiIcon"));
var _HiIconButton = _interopRequireDefault(require("../HiIconButton"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _objectSpread2.default)({
      position: 'relative'
    }, theme.typography.body2, {
      borderBottom: "1px solid ".concat(theme.palette.input.bottomLine),
      paddingLeft: 8,
      backgroundColor: theme.palette.background2,
      '&$focused': {
        backgroundColor: '#ffffff'
      },
      width: '100%',
      // Ajout d'1px pour ne pas avoir de décalage en mode error avec le border top
      '&:$error': {
        marginTop: 1
      }
    }),
    inkbar: {
      '&:not($error):after': {
        backgroundColor: theme.palette.primary.main,
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 1,
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.
      },
      '&:not($error):hover:after': {
        transform: 'scaleX(1)'
      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      }
    },
    focused: {},
    error: {
      border: "1px solid ".concat(theme.palette.error.main),
      paddingLeft: 8,
      borderRadius: 2
    },
    startAdornment: {
      fontSize: 20,
      zIndex: 1,
      marginLeft: 0,
      marginRight: 8
    },
    startAdornmentDefaultColor: {
      color: theme.palette.neutral.main
    },
    startAdornmentFocus: {
      color: theme.palette.neutral.dark
    },
    startAdornmentDisabled: {
      color: theme.palette.neutral.light
    },
    rightIcon: {
      fontSize: 20,
      width: 39,
      color: theme.palette.neutral.main
    },
    rightIconFocus: {
      color: theme.palette.neutral.dark
    },
    rightIconDisabled: {
      color: theme.palette.neutral.light
    },
    rightIconError: {
      // Ajout d'1px pour ne pas avoir de décalage en mode error avec le border right
      marginRight: '-1px'
    },
    input: (0, _objectSpread2.default)({}, theme.typography.body2, {
      caretColor: theme.palette.primary.main,
      display: 'flex',
      alignItems: 'center'
    }),
    inputPropsClassName: (0, _objectSpread2.default)({}, theme.typography.body2, {
      padding: 0
    }),
    inputText: {
      height: 40
    },
    inputTextArea: {
      minHeight: 40,
      paddingTop: 8
    },
    iconPointer: {
      zIndex: 2,
      cursor: 'pointer'
    },
    eraseButton: {
      height: 40,
      width: 40
    },
    eraseButtonLabel: {
      position: 'relative',
      top: -2
    },
    disabled: {
      borderBottom: 'none'
    },
    endAdornment: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center'
    }
  };
};
var _ref = /*#__PURE__*/_react.default.createElement(_HiIcon.default, {
  icon: "close",
  size: 20,
  color: "neutral"
});
var HiInput = /*#__PURE__*/function (_React$PureComponent) {
  function HiInput() {
    var _this;
    (0, _classCallCheck2.default)(this, HiInput);
    _this = _callSuper(this, HiInput);
    _this.handleKeyDown = function (event) {
      var key = (0, _index.default)(event);
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
      if (key === 'enter' && _this.props.onSubmit) {
        _this.props.onSubmit(event);
      }
    };
    _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    };
    _this.state = {
      focused: false
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleDivClick = _this.handleDivClick.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleReset = _this.handleReset.bind(_this);
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.getInputElement = _this.getInputElement.bind(_this);
    _this.handleOverlayRef = _this.handleOverlayRef.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(HiInput, _React$PureComponent);
  return (0, _createClass2.default)(HiInput, [{
    key: "getInputElement",
    value: function getInputElement(el) {
      this.inputElement = el;
      if (this.props.customRef) {
        this.props.customRef(this.inputElement);
      } else if (this.props.inputRef) {
        this.props.inputRef(this.inputElement);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      if (this.props.onChange) {
        this.props.onChange(event);
      }
    }
  }, {
    key: "handleReset",
    value: function handleReset() {
      if (this.props.onReset) {
        this.props.onReset();
      }
      this.inputElement.focus();
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      // Si on click sur un élément de HiInput, on garde le focus
      // Par exemple sur l'icone reset
      if (event.relatedTarget && this.overlayNode && this.overlayNode.contains(event.relatedTarget)) {
        // If blur came from erase icon => stay focused and don't call onBlur props
        if (this.eraseIconNode && this.eraseIconNode.contains(event.relatedTarget)) {
          event.preventDefault();
          event.stopPropagation();
        } else if (this.endAdornmentNode.contains(event.relatedTarget) && this.props.onBlur) {
          this.props.onBlur(event);
        }
        event.preventDefault();
        event.stopPropagation();
      } else {
        this.setState({
          focused: false
        });
        if (this.props.onBlur) {
          this.props.onBlur(event);
        }
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      if (this.endAdornmentNode && this.endAdornmentNode.contains(event.target)) {
        event.stopPropagation();
      } else {
        if (!this.state.focused) {
          this.setState({
            focused: true
          });
        }
        // If focus came from erase icon => stay focused and don't call onFocus props
        if (this.eraseIconNode && this.eraseIconNode.contains(event.relatedTarget)) {
          event.preventDefault();
          event.stopPropagation();
        } else if (this.props.onFocus) {
          this.props.onFocus(event);
        }
      }
    }
  }, {
    key: "handleDivClick",
    value: function handleDivClick(event) {
      if (this.endAdornmentNode && this.endAdornmentNode.contains(event.target)) {
        event.stopPropagation();
      } else {
        if (!this.state.focused) {
          this.setState({
            focused: true
          });
        }
        this.inputElement.focus();
      }
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      if (this.props.onMouseEnter) {
        this.props.onMouseEnter();
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      if (this.props.onMouseLeave) {
        this.props.onMouseLeave();
      }
    }
  }, {
    key: "handleOverlayRef",
    value: function handleOverlayRef(el) {
      this.overlayNode = el;
      if (this.props.overlayRef) {
        this.props.overlayRef(el);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        value = _this$props.value,
        classes = _this$props.classes,
        placeholder = _this$props.placeholder,
        startAdornment = _this$props.startAdornment,
        endAdornmentProps = _this$props.endAdornment,
        className = _this$props.className,
        error = _this$props.error,
        type = _this$props.type,
        disabled = _this$props.disabled,
        autoComplete = _this$props.autoComplete,
        autoFocus = _this$props.autoFocus,
        inputId = _this$props.inputId,
        name = _this$props.name,
        multiline = _this$props.multiline,
        rows = _this$props.rows,
        inputClassName = _this$props.inputClassName,
        onReset = _this$props.onReset,
        spellcheck = _this$props.spellcheck,
        startAdornmentColor = _this$props.startAdornmentColor,
        inputProps = _this$props.inputProps;
      var focused = this.state.focused;
      var overlayProps = (0, _objectSpread2.default)({
        className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.disabled, disabled && !error), classes.inkbar, !disabled), classes.focused, focused), classes.error, error), className)
      }, !disabled && {
        onClick: this.handleDivClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, {
        ref: this.handleOverlayRef
      });
      var leftIcon;
      if (!!startAdornment) {
        var leftIconProps = {
          color: startAdornmentColor,
          onClick: this.props.onLeftIconClick,
          className: (0, _classnames.default)(classes.startAdornment, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.startAdornmentDefaultColor, !startAdornmentColor), classes.startAdornmentFocus, focused && !startAdornmentColor), classes.startAdornmentDisabled, disabled && !startAdornmentColor), classes.iconPointer, this.props.onLeftIconClick))
        };
        if (typeof startAdornment === 'string') {
          leftIcon = /*#__PURE__*/_react.default.createElement(_HiIcon.default, (0, _extends2.default)({
            icon: startAdornment
          }, leftIconProps));
        } else if ((0, _typeof2.default)(startAdornment) === 'object') {
          // Icon component as prop
          leftIcon = (0, _objectSpread2.default)({}, startAdornment);
          leftIcon.props = (0, _objectSpread2.default)({}, leftIcon.props, {}, leftIconProps, {
            className: "".concat(leftIconProps.className, " ").concat(leftIcon.props.className)
          });
        }
      }

      // Build endAdornment with eraseIcon + endAdornmentProps
      var eraseIcon = !multiline && onReset && focused && !disabled && value.length > 0 && /*#__PURE__*/_react.default.createElement(_HiIconButton.default, {
        className: classes.eraseButton,
        classes: {
          label: classes.eraseButtonLabel
        },
        onClick: this.handleReset,
        onBlur: this.handleBlur,
        ref: function ref(el) {
          _this2.eraseIconNode = el;
        }
      }, _ref);
      var endAdornment = endAdornmentProps;
      if (typeof endAdornmentProps === 'string' && endAdornmentProps !== '') {
        endAdornment = /*#__PURE__*/_react.default.createElement(_HiIcon.default, {
          icon: endAdornmentProps,
          size: 20,
          color: "neutral",
          onClick: this.props.onRightIconClick,
          className: (0, _classnames.default)(classes.rightIcon, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.rightIconFocus, focused), classes.rightIconDisabled, disabled), classes.rightIconError, error), classes.iconPointer, this.props.onRightIconClick))
        });
      }
      return /*#__PURE__*/_react.default.createElement("div", overlayProps, /*#__PURE__*/_react.default.createElement(_Input.default, {
        id: inputId,
        type: type,
        className: classes.input,
        disableUnderline: true,
        onChange: this.handleChange,
        value: value,
        placeholder: placeholder,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        onBlur: this.handleBlur,
        inputRef: this.getInputElement,
        disabled: disabled,
        multiline: multiline,
        rows: rows,
        fullWidth: true,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        name: name,
        startAdornment: leftIcon,
        endAdornment: /*#__PURE__*/_react.default.createElement("div", {
          className: classes.endAdornment,
          ref: function ref(el) {
            _this2.endAdornmentNode = el;
          }
        }, eraseIcon, endAdornment),
        inputProps: (0, _objectSpread2.default)({
          spellCheck: spellcheck ? 'true' : 'false',
          className: (0, _classnames.default)(inputClassName, classes.inputPropsClassName, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.inputText, !multiline), classes.inputTextArea, multiline))
        }, inputProps)
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof nextProps.focused !== 'undefined' && nextProps.focused !== prevState.focused) {
        return {
          focused: nextProps.focused
        };
      }
      return null;
    }
  }]);
}(_react.default.PureComponent);
HiInput.defaultProps = {
  value: '',
  placeholder: '',
  inputId: '',
  name: '',
  startAdornment: '',
  endAdornment: '',
  type: 'text',
  multiline: false,
  error: false,
  onlyNumbers: false,
  spellcheck: false
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HiMuiHiInput'
})(HiInput);